'use strict';

/* globals $ */

var React = require('react');
var _ = require('lodash');

var at = require('../utils/environment');


var BaseCard = {
    answerInvitation: function(/*info*/) { return true; },
    render: function() { return null; }
};

function rawHTMLRender(html) {
    return function() {
        return React.createElement('div', {
            dangerouslySetInnerHTML: {__html: html}
        });
    };
}


var Card, newCard;
Card = function shorthand(definition) {
    var newInstance = {};

    if (typeof(definition) === 'function')
        newInstance.render = rawHTMLRender(definition());
    else newInstance = definition;

    Card.register(Card.create(newInstance));
};
newCard = Card;

Card.create = function(definition) {
    definition = _.extend({}, BaseCard, definition);
    definition.klass = React.createClass(definition);
    return definition;
};

Card.register = function(card) {
    $('.bastian').trigger('card_register.bastian', card);
};

if (at.client && window.$) (function() {
    var run = false;
    var transplantCards = function() {
        if (run) return;
        else run = true;
        $('.bastian-card-mobile, .bastian_card__mobile').each(function() {
            var html = $(this).remove()[0].outerHTML;
            newCard(function(){ return html; });
        });
    };

    $(document).ready(transplantCards);
    setTimeout(transplantCards, 30 * 1000);
    $(window).on('load', transplantCards);
})();

module.exports = Card;
